module.exports = __webpack_public_path__ + "img/74d4095aeda617db6cdc4b660397e9c3.jpg";